module.exports = __webpack_public_path__ + "static/img/icon-img2.6dd78e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-img2.png
// module id = tFVK
// module chunks = 1